import React from "react";
import RowComponent from "../../../basic-row";
import TopActionsComponent from "../../../top-actions-component";
import AddModalComponent from "../../../add-modal-component";
import Header from "../../../header";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import { CircularProgress } from "material-ui";
import request from "../../../../config/axios-config";
import { connect } from "react-redux";
import * as ErrorAction from "../../../../redux/action/error-action";
import Select from "react-select";

class DepartmentsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      users: [],
      userEmails: [],
      showAdd: false,
      wasDataLoaded: false,
      loadingData: false,
      emptyData: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentWillUnmount() {
    this.props.hideError();
    this.setState({ wasDataLoaded: false });
  }

  refreshData = () => {
    this.setState({ loadingData: true });
    request({
      method: "get",
      url: this.props.url + "/all",
    })
      .then((response) => {
        const departments = (response.data && response.data.departments) || [];
        const users = (response.data && response.data.users) || [];
        const chiefIds = (response.data && response.data.chiefIds) || {};
        let userEmails = users.map((t, i) => {
          return { value: t.id, label: t.email };
        });
        let isEmptyData = departments.length === 0;
        this.setState({
          data: departments,
          user: users,
          userEmails: userEmails,
          wasDataLoaded: true,
          loadingData: false,
          emptyData: isEmptyData,
          users,
          chiefIds,
        });
      })
      .catch((err) => {
        this.setState({ loadingData: false });
        this.props.showError("Incarcarea paginii a esuat. Va rog reincercati!");
      });
  };

  onDeleteClicked = (index, id) => {
    request({
      method: "post",
      url: this.props.url + "/delete/" + id,
    })
      .then((response) => {
        let newData = [...this.state.data];
        newData.splice(index, 1);
        this.setState({ data: newData });
      })
      .catch((err) => {
        this.props.showError("Stergerea a esuat. Va rog reincercati!");
      });
  };

  onEditClicked = (id, name) => {
    this.setState({
      showEdit: true,
      editId: id,
      editName: name,
    });
    this.props.onDialogVisible(true);
  };

  onAddClicked = () => {
    this.setState({
      showAdd: true,
    });
    this.props.onDialogVisible(true);
  };

  addFinished = () => {
    this.setState({ showAdd: false });
    this.refreshData();
    this.props.onDialogVisible(false);
  };

  editFinished = () => {
    this.setState({
      showEdit: false,
      editId: null,
    });
    this.refreshData();
    this.props.onDialogVisible(false);
  };

  // Chiefs approve the flow's "Sef compartiment" step for this department's papers.
  onChangeChiefs = (departmentId, selected) => {
    this.props.hideError();
    const userIds = (selected || []).map((option) => option.value);
    // Show the new selection right away, so a second pick builds on this one.
    this.setState((oldState) => ({
      chiefIds: { ...oldState.chiefIds, [departmentId]: userIds },
    }));
    request({
      url: `${this.props.url}/${departmentId}/chiefs`,
      method: "POST",
      data: { userIds },
    })
      .then(() => {
        this.refreshData();
      })
      .catch(() => {
        this.props.showError("Salvarea sefilor de compartiment a esuat!");
      });
  };

  renderChiefs = (t) => {
    const chiefIds = (this.state.chiefIds && this.state.chiefIds[t.id]) || [];
    return (
      <td style={{ minWidth: "320px" }}>
        <Select
          multi
          options={this.state.userEmails}
          value={chiefIds}
          placeholder="Fără șef (pasul de șef se sare)"
          onChange={(selected) => this.onChangeChiefs(t.id, selected)}
          searchable={true}
        />
      </td>
    );
  };

  render() {
    let rows = this.state.data.map((t, i) => {
      return (
        <RowComponent
          key={t.id}
          id={t.id}
          name={t.name}
          index={i}
          onDeleteClicked={this.onDeleteClicked}
          onEditClicked={this.onEditClicked}
          users={this.state.users}
          extraTd={this.renderChiefs(t)}
        />
      );
    });

    return (
      <div>
        <RedirectIfNotLogged />

        <Header title={this.props.title} />

        {this.state.showAdd === true ? (
          <AddModalComponent
            url={this.props.url + "/add/?name="}
            onCancel={this.addFinished}
            title={this.props.addTitle}
          />
        ) : (
          ""
        )}

        {this.state.showEdit === true && this.state.editId ? (
          <AddModalComponent
            url={this.props.url + "/add/?name="}
            onCancel={this.editFinished}
            title={this.props.editTitle}
            id={this.state.editId}
            initialName={this.state.editName}
          />
        ) : (
          ""
        )}

        {this.state.loadingData ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div style={{ width: "75%", margin: "0 auto" }}>
              {this.state.emptyData ? (
                <div>
                  <div style={{ float: "right" }}>
                    <TopActionsComponent onAddClicked={this.onAddClicked} />
                  </div>
                  <div className="ds-empty"><h3>Nu exista date!</h3></div>
                </div>
              ) : (
                <div>
                  <div style={{ float: "right" }}>
                    <TopActionsComponent onAddClicked={this.onAddClicked} />
                  </div>
                  <table className="table  table-hover table-responsive">
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <th>Edit/Delete</th>
                        <th>Șefi compartiment (aprobă pasul de șef)</th>
                      </tr>
                      {rows}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userDepartment: state.login.user.department,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (text) => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentsPage);
